<template>
  <div style="background-color:whitesmoke!important;">
    <va-card style="height:600px!important;background-color:white!important;">
      <vue-element-loading :active="visible" :is-full-screen="true" />
      <div class="row">
        <div class="flex md3 sm6 xs12"></div>
        <div class="flex md6 sm6 xs12">
          <va-card class="shadow p-3 mb-5 bg-white rounded" style="height:400px!important;">
            <h4 style="font-size:24px!important;padding-top:20px;" class="news2">UPDATE WLPA</h4>
            <form @submit="onSubmit">
              <div style="padding-top:20px;" class="flex md12 sm6 xs12">
                <va-input required v-model="name" placeholder="WLPA" />
              </div>
              <div align="right" style="padding-top:40px!important">
                <button class="btn btn-info" type="submit">UPDATE</button>
              </div>
            </form>
          </va-card>
        </div>
        <div class="flex md3 sm6 xs12"></div>
      </div>
    </va-card>
  </div>
</template>

<script>
import axios from 'axios'
import VueElementLoading from 'vue-element-loading'
export default {
  components: {
    VueElementLoading,
  },
  props: ['id'],
  data () {
    return {
      type: '',
      visible: false,
      name: null,
      msg: '',
      dat: [],
      data: [],
    }
  },
  mounted: function () {
    this.getList()
  },
  methods: {
    onSubmit (evt) {
      // this.visible = true
      var data = {}
      data['name'] = this.name
      console.log(this.data)
      evt.preventDefault()
      axios({
        method: 'POST',
        url: '/wlpa/edit/' + this.id,
        headers: {
          token: localStorage.getItem('token'),
        },
        data: data,
      })
        .then(response => {
          this.msg = response.data.msg
          if (response.data.status === true) {
            this.visible = 'false'
            this.$dlg.alert(
              this.msg,
              () => {
                this.$router.push('/wlpa')
              },
              { messageType: 'success' }
            )
          } else {
            this.visible = 'false'
            this.$dlg.alert(
              this.msg,
              () => {
                this.$router.push('/wlpa')
              },
              { messageType: 'error' }
            )
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    getList () {
      this.visible = true
      axios({
        method: 'GET',
        url: '/wlpa/view/' + this.id,
        headers: {
          token: localStorage.getItem('token'),
        },
        data: { id: this.id },
      })
        .then(response => {
          // console.log(response.data.data)
          if (response.data.status === true) {
            this.data = response.data.data
            this.name = response.data.data.name
            var dt = this.data.create_date
            dt = new Date(dt)
            dt = dt.toString()
            dt = dt.slice(0, 15)
            this.data.create_date = dt
          } else {
          }

          this.visible = false
        })
        .catch(e => {
          console.log(e)
          this.visible = false
          this.errors.push(e)
          this.msg = 'failed'
        })
    },
  },
}
</script>
<style>
/* .card .content figure
{
  box-shadow: none!important;
} */
</style>
